export function getNewItem(t, possibleChild, chosenLevel, canEdit) {
    return {
        id: `new-${possibleChild?.type?.toLowerCase()}-${chosenLevel?.id}-${chosenLevel?.children.length}`,
        name: t(`new_${possibleChild?.type?.replace('-', '_')}`),
        type: `${possibleChild?.type}`,
        properties: [
            {
                label: t('name'),
                type: 'text',
                value: t(`new_${possibleChild?.type?.replace('-', '_')}`),
                main: true,
                required: true,
                key: 'name',
                allowEdit: canEdit,
            },
            possibleChild?.kind === 'asset' && {
                label: t('discipline'),
                type: 'singleSelect',
                value: null,
                options: [
                    { id: 'mechanical', label: t('mechanical') },
                    { id: 'electrical', label: t('electrical') },
                    { id: 'instrumentation', label: t('instrumentation') },
                    { id: 'plumbing', label: t('plumbing') },
                ],
                main: true,
                required: true,
                key: 'discipline',
                allowEdit: canEdit,
            },
            {
                label: t('category'),
                type: 'singleSelect',
                value: null,
                options: [],
                main: true,
                required: true,
                key: 'category',
                allowEdit: canEdit,
            },
            possibleChild?.kind === 'asset' && {
                label: t('isReal'),
                type: 'singleSelect',
                value: null,
                options: [
                    { id: true, label: t('yes') },
                    { id: false, label: t('no') },
                ],
                main: true,
                required: true,
                key: 'isReal',
                allowEdit: canEdit,
            },
            possibleChild?.kind === 'asset' && {
                label: t('system'),
                type: 'multiSelect',
                value: null,
                options: [],
                main: true,
                required: false,
                key: 'system',
                allowEdit: canEdit,
            },
            possibleChild?.kind === 'asset' && {
                label: t('subsystem'),
                type: 'text',
                value: null,
                main: true,
                required: false,
                key: 'subsystem',
                allowEdit: canEdit,
            },
            possibleChild?.kind === 'asset' && {
                label: t('manufacturer'),
                type: 'singleSelect',
                options: [],
                value: null,
                main: true,
                required: true,
                key: 'manufacturer',
                allowEdit: canEdit,
            },
            possibleChild?.kind === 'asset' && {
                label: t('model_number'),
                type: 'text',
                value: null,
                main: true,
                required: true,
                key: 'model_number',
                allowEdit: canEdit,
            },
            possibleChild?.kind === 'asset' && {
                label: t('serial_number'),
                type: 'text',
                value: null,
                main: true,
                required: true,
                key: 'serial_number',
                allowEdit: canEdit,
            },
            {
                label: t('out_of_service'),
                type: 'bool',
                value: false,
                main: true,
                required: true,
                key: 'out_of_service',
                allowEdit: canEdit,
            },
        ].filter(Boolean),
        commissioning: false,
        children: [],
    };
}

export function getNewPlant(t, canEdit) {
    return {
        id: 'newPlant',
        name: t('new_plant'),
        icon: 'factory',
        category: null,
        type: 'plant',
        properties: [
            {
                label: t('name'),
                type: 'text',
                value: () => t('new_plant'),
                main: true,
                required: true,
                key: 'name',
                allowEdit: canEdit,
            },
            {
                label: t('category'),
                type: 'singleSelect',
                value: null,
                options: [],
                main: true,
                required: true,
                key: 'category',
                allowEdit: canEdit,
            },
            {
                label: t('organization'),
                type: 'singleSelect',
                value: null,
                options: [],
                main: true,
                required: true,
                key: 'organization',
                allowEdit: canEdit,
            },
            {
                label: t('department'),
                type: 'singleSelect',
                value: null,
                options: [],
                main: true,
                required: true,
                key: 'department',
                allowEdit: canEdit,
            },
            {
                label: t('installation_date'),
                type: 'date',
                value: null,
                main: true,
                required: true,
                key: 'installation_date',
                allowEdit: canEdit,
            },
            {
                label: t('contact_emails'),
                type: 'multiText',
                value: null,
                placeholder: 'email@email.com',
                main: true,
                required: true,
                key: 'contactEmails',
                allowEdit: canEdit,
            },
            {
                label: t('out_of_service'),
                type: 'bool',
                value: false,
                main: true,
                required: true,
                key: 'out_of_service',
                allowEdit: canEdit,
            },
        ],
        children: [],
    };
}

export function getNewSystem(t, canEdit) {
    return {
        id: 'newSystem',
        name: t('new_system'),
        properties: [
            {
                label: t('name'),
                type: 'text',
                value: t('new_system'),
                main: true,
                required: true,
                key: 'name',
                allowEdit: canEdit,
            },
            {
                label: t('organization'),
                type: 'singleSelect',
                options: [],
                value: null,
                main: true,
                required: true,
                key: 'organization',
                allowEdit: canEdit,
            },
            {
                label: t('cost_center'),
                type: 'singleSelect',
                options: [],
                value: null,
                main: true,
                required: true,
                key: 'cost_center',
                allowEdit: canEdit,
            },
            {
                label: t('department'),
                type: 'singleSelect',
                options: [],
                value: null,
                main: true,
                required: true,
                key: 'department',
                allowEdit: canEdit,
            },
        ],
        parent: null,
        children: [],
    };
}
